import { toast } from "react-toastify";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import useLeadNotes from "common/datahooks/useLeadNotes";

export default function DeleteNoteDialog({
  profileId,
  noteId,
  onClose,
}: {
  profileId: string;
  noteId: string;
  onClose: () => void;
}) {
  const { deleteLeadNote, isDeletingLeadNote } = useLeadNotes();

  function onDelete() {
    deleteLeadNote({ profileId, noteId }).catch(() => {
      toast.error("Error deleting Note");
    });
    onClose();
  }
  return (
    <Dialog
      open={!!noteId}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          onClose();
        }
      }}
    >
      <DialogContent className="w-96">
        <DialogTitle>Delete note?</DialogTitle>
        <DialogDescription className="mb-8">
          Are you sure you want to delete this note?
        </DialogDescription>
        <Button
          variant="outline-danger"
          className="mb-4"
          onClick={onDelete}
          isLoading={isDeletingLeadNote}
        >
          Yes
        </Button>
        <Button
          variant="ghost-black"
          disabled={isDeletingLeadNote}
          onClick={onClose}
        >
          No
        </Button>
      </DialogContent>
    </Dialog>
  );
}
